import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PhysicalPrepaidCardStatusHistoryResponse } from '@/repositories/generated';

const responses: PhysicalPrepaidCardStatusHistoryResponse[] = [
  {
    histories: [
      {
        acquirer: undefined,
        adminUserId: undefined,
        changeDateTime: '2024-08-16T03:52:16.691Z',
        company: undefined,
        id: '1',
        shop: undefined,
        status: 'CREATE',
      },
    ],
    physicalPrepaidCardNumber: '0000000000000001',
  },
  {
    histories: [
      {
        acquirer: undefined,
        adminUserId: undefined,
        changeDateTime: '2024-08-16T03:52:16.691Z',
        company: undefined,
        id: '1',
        shop: undefined,
        status: 'CREATE',
      },
      {
        acquirer: {
          id: '2',
          name: 'テストアクワイアラ2',
        },
        adminUserId: '2',
        changeDateTime: '2024-08-16T03:52:16.691Z',
        company: {
          id: '00002',
          name: 'テスト企業2',
        },
        id: '2',
        shop: {
          id: '12345678',
          name: 'テスト店舗2',
        },
        status: 'ACTIVE',
      },
    ],
    physicalPrepaidCardNumber: '0000000000000002',
  },
  {
    histories: [
      {
        acquirer: undefined,
        adminUserId: undefined,
        changeDateTime: '2024-08-16T03:52:16.691Z',
        company: undefined,
        id: '1',
        shop: undefined,
        status: 'CREATE',
      },
      {
        acquirer: {
          id: '2',
          name: 'テストアクワイアラ2',
        },
        adminUserId: '2',
        changeDateTime: '2024-08-16T03:52:16.691Z',
        company: {
          id: '00002',
          name: 'テスト企業2',
        },
        id: '2',
        shop: {
          id: '12345678',
          name: 'テスト店舗2',
        },
        status: 'ACTIVE',
      },
      {
        acquirer: {
          id: '3',
          name: 'テストアクワイアラ3',
        },
        adminUserId: '3',
        changeDateTime: '2024-08-16T03:52:16.691Z',
        company: {
          id: '00003',
          name: 'テスト企業3',
        },
        id: '3',
        shop: {
          id: '12345678',
          name: 'テスト店舗3',
        },
        status: 'DISABLED',
      },
    ],
    physicalPrepaidCardNumber: '0000000000000003',
  },
];

export const physicalPrepaidCardHistory = http.get(
  createMockEndpoint('/physical_prepaid_card/:cardNumber/history'),
  async ({ params }) => {
    await delay(500);
    return HttpResponse.json(responses.find((response) => response.physicalPrepaidCardNumber === params.cardNumber), { status: 200 });
  },
);
